import React from "react";
import { Routes, Route, Navigate } from "react-router";
import useAsyncReducer from "components/app/useAsyncReducer";
import LoadingView from "components/styled/loadingView/LoadingView";
import authenticationReducers from "./Reducers";
import { AsyncRecoverPassword } from "componentes/app/LazyComponents";
import loadable from "@loadable/component";

const Validating = loadable(() => import("componentes/auth/Validating"), {
  resolveComponent: (comps) => comps.Validating,
});
const LoginFormContainer = loadable(() =>
  import("componentes/user/LoginContainer")
);
const IngresarAppInfo = loadable(() =>
  import("componentes/auth/IngresarAppInfo")
);
const IngresarAppSuccess = loadable(() =>
  import("componentes/auth/IngresarAppSuccess")
);
const SignupAgencia = loadable(() =>
  import("./signup/agenciero/SignupAgencia")
);
const SignupClienteFinal = loadable(() =>
  import("./signup/clienteFinal/SignupClienteFinal")
);

const SignupProductor = loadable(() =>
  import("./signup/productor/SignupProductor")
);
const StepperProductor = loadable(() =>
  import("./signup/productor/StepperProductor")
);
const SelectorTipoProductor = loadable(() =>
  import("./signup/productor/SelectorTipoProductor")
);
const SignupProductorSancor = loadable(() =>
  import("./signup/productor/SingupProductorSancor")
);

const SignupVendedor = loadable(() =>
  import("./signup/vendedor/SignupVendedor")
);

const AuthenticationRoutes = () => {
  const loading = useAsyncReducer([authenticationReducers]);
  return (
    <>
      {loading && <LoadingView />}
      {!loading && (
        <Routes>
          <Route path="/validating" element={<Validating />} />
          <Route path="/agencias/signup/:position" element={<SignupAgencia />} />
          <Route path="/agencias/signup" element={<SignupAgencia />} />
          <Route path="/clientes/signup/:position" element={<SignupClienteFinal />} />
          <Route path="/clientes/signup" element={<SignupClienteFinal />} />
          <Route path="/productores/tipo" element={<SelectorTipoProductor />} />
          <Route path="/productores/sancor" element={<SignupProductorSancor />} />
          <Route path="/productores/sancor/signup" element={<StepperProductor />} />
          <Route path="/productores/otros/signup" element={<SignupProductor />} />
          <Route path="/vendedores/signup" element={<SignupVendedor />} />
          <Route path="/login/old" element={<LoginFormContainer />} />
          <Route path="/login/password/:token" element={<AsyncRecoverPassword />} />
          <Route path="/actualizando/inicio" element={<IngresarAppInfo />} />
          <Route path="/actualizando/success" element={<IngresarAppSuccess />} />
          <Route path="*" element={<Navigate to="/validating" replace />} />
        </Routes>
      )}
    </>
  );
};

export default AuthenticationRoutes;
